import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from '../../common/customfunctions';
import { ApiMethod } from '../../apimethods/api-method';
import { GlobalConstants } from '../../common/global-constants';
import { Observable } from 'rxjs';
declare var $;

@Component({
  selector: 'app-defect-new',
  templateUrl: './defect-new.component.html',
  styleUrls: ['./defect-new.component.css']
})
/** Defect-New component*/
export class DefectNewComponent implements OnInit {

  dtOptions: any; tableData = [];
  dataTable: any; @ViewChild('dataTable', { static: false }) table; dataSet: any;
  journalList: any; issueList: any; articleList: any;
  DefectAreaList: any; DefectCategoryList: any; DefectInstructionList: any;
  DefectStatusListAPI: any;
  CategoryIdPop: any; Acronym: string; ArticleNo: string; VolIssue: string; AreaName: string;
  Category: string; Instructions: string; ResponseMode: string;
  Volume: any;
  Description: any;
  title: string;
  showModal: boolean;
  DownloadFilepath: any;
  popUpButtonText: string;
  Response: string;
  file: any;
  fileBase64: any;
  FileName: any;
  uploadFilePath: any;
  RequestFeedback: any;
  reportTypeList: any;
  DefectDueDate: any;
  disableValidation: boolean = false;
  minDate: string;
  maxDate: string;
  status: string;
  RootCauseDates: any;
  PreventiveDates: any;
  CorrectiveDates: any;
  JournalId: string;
  DefectStatus: any;
  DefectId: any;
  localEid: any;
  journalIdfromMaster: any;

  // used to capture the event and sent to parent to load page on saved a new record
  @Output() recordSaved = new EventEmitter<void>();


  constructor(private router: Router, private route: ActivatedRoute) {
    this.LoadPopUpForNewDefect();
  }
  ngOnInit(): void {
  }

  LoadPopUpForNewDefect(): void {
    this.GetJournalsList();
    this.GetDefectAreaList();
    this.GetDefectInstruction();
    this.GetStatusList();
    this.loadGeneralmethod();
    this.getReportTypeList();
    this.GetDueDateValidation();
    this.GetVolIssArt();

    /*$("#DefectStatus").val([]).trigger("change");*/

    $("#ddlDefectCategory").select2({
      placeholder: "Select Status", dropdownParent: "#DivAddData"
    });
    $("#ddlDefectCategory").val([]).trigger("change");

    

    $("#ddlFeedbackRequest").select2({
      placeholder: "No", dropdownParent: "#DivAddData"
    });
    $("#ddlFeedbackRequest").val([]).trigger("change");
  }

  showData(): void {
    this.ShowInfoPopUp();
  }

  showViewForRPCusers(): void {
    this.ClearData();
    if (localStorage.aEID != 0) {
      var dataParam = {
        Id: localStorage.aEID,
        UpdatedBy: localStorage.aLoginID,
      };
      $("#LoadingImage").show();

      ApiMethod.postMethod('api/populatedefectmgt', dataParam).subscribe(
        result => {
          let _dataItem = result.DataItem;
          let _defectdata = result.defectData;

          //Show Data
          if (_dataItem.length != 0) {
            this.uploadFilePath = _dataItem[0].Attachments;
            $("#ddlJournals").val(_dataItem[0].JournalId).change();
            $("#ddlIssue").val(_dataItem[0].IssueId).change();
            $("#ddlArticle").val(_dataItem[0].ArticleId).change();
            $("#ddlDefectArea").val(_dataItem[0].DefectAreaId).change();
            $("#ddlDefectCategory").val(_dataItem[0].DefectCategoryId).change();
            this.ResponseMode = _dataItem[0].DefectViewProcess;
            //Populate Category from Area and Selected Id
            this.GetDefectCategoryList(_dataItem[0].DefectCategoryId);
            $("#ddlDefectInstruction").val(_dataItem[0].DefectInstructionId).change();
            $("#ddlFeedbackRequest").val(_dataItem[0].RequestFeedback).change();
            $("#txtDescription").val(_dataItem[0].Description);
            $("#LoadingImage").hide();

            if (_dataItem[0].DefectDueDate != null) {
              $("#Txt_DefectDueDate").val(GlobalConstants.SetValue_FormatDate(_dataItem[0].DefectDueDate));
            }
          }
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });

      $("#LoadingImage").hide();
      this.title = "View Defect Details"; //Dynamic Data
      this.DisablepopupAdd();
      $('#UpdateAdd').hide();
      $('#DivAddData').show();

    }


  }
  GetDefectCategoryList(selectedId = 0): void {
    var dataParam = {
      DefectAreaId: $("#ddlDefectArea").val()
    };
    ApiMethod.postMethod("api/defectcategorylist", dataParam).subscribe(
      result => {
        this.DefectCategoryList = result.dataItem;
        this.CategoryIdPop = selectedId;
      }, error => {
        $("#LoadingImage").hide();

      });
  }

  ClearData(): void {
    $("#ddlJournals").val(0).change();
    $("#ddlDefectArea").val(0).change();
    $("#ddlIssue").val(0).change();
    $("#ddlArticle").val(0).change();
    $("#ddlDefectCategory").val(0).change();
    $("#ddlDefectInstruction").val(0).change();
    $("#txtDescription").val('');
    $("#Txt_DefectDueDate").val('');
    $("#doc_Defectuploadfile").val('').change();
    $("#ddlFeedbackRequest").val(0).change();
    $("#doc_Defectuploadfile").val('').change();

    this.file = null;

  }

  hide() {
    this.showModal = false;
  }

  //Add and Update the  Defect Data
  UpdateDefectMgt(): void {
    $("#LoadingImage").show();
    if ($("#ddlJournals").val() == 0) {
      ngswal("Warning !", "Please Select Journal !", "warning");
    }
    else if ($('#ddlDefectArea').val() == 0) {
      ngswal("Warning !", "Please Select Defect Area !", "warning");
    }
    else if ($('#ddlDefectCategory').val() == 0) {
      ngswal("Warning !", "Please Select Defect Category !", "warning");
    }

    else if ($('#ddlDefectInstruction').val() == 0) {
      ngswal("Warning !", "Please Select Defect Instruction !", "warning");
    }
    else if ($('#Txt_DefectDueDate').val() == '') {
      ngswal("Warning !", "Please Enter Defect Due Date !", "warning");
    }
    else if ($('#txtDescription').val() == '') {
      ngswal("Warning !", "Please Enter Defect Description !", "warning");
    }
    else {
      let fileName = null;
      let fileSize = null;
      if (this.file != null) {
        fileName = this.file.name;
        fileSize = this.file.size;
      } else {
        this.fileBase64 = null;
      }

      var dataParam = {
        Id: localStorage.aEID,
        JournalId: $("#ddlJournals").val(),
        IssueId: $("#ddlIssue").val(),
        ArticleId: $("#ddlArticle").val(),
        DefectAreaId: $("#ddlDefectArea").val(),
        DefectCategoryId: $("#ddlDefectCategory").val(),
        DefectInstructionId: $("#ddlDefectInstruction").val(),
        RequestFeedback: $("#ddlFeedbackRequest").val(),
        Description: $("#txtDescription").val(),
        DefectDueDate: $("#Txt_DefectDueDate").val(),
        ProductionResponse: $("#txtDefectResponse").val(),
        DefectStatus: $("#DefectStatus").val(),
        RespondedBy: localStorage.roleId,
        UpdatedBy: localStorage.aLoginID,
        PublisherId: localStorage.aPubID,
        fileName: fileName,
        fileSize: fileSize,
        fileAsBase64: this.fileBase64,

      };

      ApiMethod.postMethod("api/updatedefect", dataParam).subscribe(
        result => {
          this.recordSaved.emit(); // capture the save event to load the parent page
          if (result.dataItem == 'Defect details already available !') {
            ngswal({
              position: 'top-end',
              type: "warning",
              title: "Record Exist !",
              text: result.dataItem,
              showConfirmButton: true,
            });
          } else {
            ngswal({
              position: 'top-end',
              type: "success",
              title: "Updated Successfully!",
              showConfirmButton: true,
            });
          }
          $('#DivAddData').hide();
          $("#LoadingImage").hide();
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });
    }
  }

  hides(): void {
    this.showModal = false;
    $("#LoadingImage").hide();
  }
  hideAddData() {
    $('#DivAddData').hide();
    $("#LoadingImage").hide();

  }


  //  display the values for edit field either response / edit defect 
  ShowInfoPopUp(): void {
    if (this.DefectStatus == 'Journal') {
      localStorage.aEID = 0;
    }
    $("#LoadingImage").show();

    $('#DivAddData').show();
   
    this.ClearData();
    if (localStorage.aEID != 0) {
      var dataParam = {
        Id: localStorage.aEID,
        UpdatedBy: localStorage.aLoginID,
      };

      ApiMethod.postMethod('api/populatedefectmgt', dataParam).subscribe(
        result => {
          let _dataItem = result.DataItem;
          let _defectdata = result.defectData;
          //Role Based UI Changes
          var menuList = JSON.parse(localStorage.aMenuList);
          var RootCauseAnalysis = menuList.find(
            (menuItem) => menuItem.MenuID == 77);

          var PreventiveAction = menuList.find(
            (menuItem) => menuItem.MenuID == 78);

          var CorrectiveAction = menuList.find(
            (menuItem) => menuItem.MenuID == 79);

          var Approver = menuList.find((menuItem) => menuItem.MenuID == 87);
          var Reject = menuList.find((menuItem) => menuItem.MenuID == 88);

          //Show Data
          if (_dataItem.length != 0) {
            this.uploadFilePath = _dataItem[0].Attachments;
            $("#ddlJournals").val(_dataItem[0].JournalId).change();
            $("#ddlIssue").val(_dataItem[0].IssueId).change();
            $("#ddlArticle").val(_dataItem[0].ArticleId).change();

            $("#ddlDefectArea").val(_dataItem[0].DefectAreaId).change();
            $("#ddlDefectCategory").val(_dataItem[0].DefectCategoryId).change();
            this.ResponseMode = _dataItem[0].DefectViewProcess;
            //Populate Category from Area and Selected Id
            this.GetDefectCategoryList(_dataItem[0].DefectCategoryId);

            $("#ddlDefectInstruction").val(_dataItem[0].DefectInstructionId).change();
            $("#ddlFeedbackRequest").val(_dataItem[0].RequestFeedback).change();
            $("#txtDescription").val(_dataItem[0].Description);

            if (_dataItem[0].DefectDueDate != null) {
              $("#Txt_DefectDueDate").val(GlobalConstants.SetValue_FormatDate(_dataItem[0].DefectDueDate));
            }

            if (_defectdata[0].DefectViewProcess == 'Response') { //loads the defect details for RPC users as disabled fields to view
              this.DisablepopupAdd();
              $("#UpdateAdd").hide();

              $('#DivAddData').show();//hidel

              this.Response = "Defect Response Details";
            }

          }
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });

      $("#LoadingImage").hide();
      $("#supportfilename").show();
      this.title = "Update Defect Details"; //Dynamic Data
      this.popUpButtonText = "Update";
    }
    else {
      //set the journal id when called from journal master for creating a new defect
      if (this.DefectStatus == 'Journal') { //reset the values except for journal

        $("#ddlJournals").val(this.journalIdfromMaster).change();
        $("#ddlJournals").attr('disabled', 'disabled');
        $("#ddlIssue").val(0).change();
        $("#ddlArticle").val(0).change();
        $("#ddlDefectArea").val(0).change();
        $("#ddlDefectCategory").val(0).change();
        $("#ddlDefectInstruction").val(0).change();
        $("#txtDescription").val('');
        $("#Txt_DefectDueDate").val('');
        $("#doc_Defectuploadfile").val('').change();
       
      } else { $("#ddlJournals").attr('disabled', false); }
      
      this.title = "Add Defect Details"; // Dynamic Data
      this.popUpButtonText = "Save";
      $("#supportfilename").hide();
    }

  }
  DisablepopupAdd() {
    $("#ddlJournals").attr('disabled', 'disabled');
    $("#ddlIssue").attr('disabled', 'disabled');
    $("#ddlArticle").attr('disabled', 'disabled');
    $("#ddlDefectArea").attr('disabled', 'disabled');
    $("#ddlDefectCategory").attr('disabled', 'disabled');
    $("#ddlDefectInstruction").attr('disabled', 'disabled');
    $("#txtDescription").attr('disabled', 'disabled');
    $("#Txt_DefectDueDate").attr('disabled', 'disabled');
    $("#doc_Defectuploadfile").attr('disabled', 'disabled');
    $("#ddlFeedbackRequest").attr('disabled', 'disabled');


  }

  GetVolIssArt() {
    $("#LoadingImage").show();
    var dataParam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      JournalId: $('#ddlJournals').val()
    };
    ApiMethod.postMethod("api/IssuearticlesList", dataParam).subscribe(
      result => {
        this.articleList = result.ArticleList;
        this.issueList = result.VolIssueList;
        $("#ddlIssue").val(0).change();
        $("#ddlArticle").val(0).change();
      }, error => {
        $("#LoadingImage").hide();
      });
  }


  loadGeneralmethod() {

    $('.select2').select2({ dropdownParent: '#divMainFilter', placeholder: "Select Journals" });
    $('.ddlselect').val([]).trigger('change');
    ApiMethod.getBaseUrl();
    $('#divDataBody').css('height', GlobalConstants.size.height - 140);
    $('#txtDescription,#txtDefetResponse').css('height', GlobalConstants.size.height - 460);
    $('#Txt_rootCause, #Txt_PreventiveAction,#Txt_CorrectiveAction').css('height', GlobalConstants.size.height - 620);
  }

  GetDueDateValidation() {

    var today = new Date();
    var tenDaysFromNow = new Date(today.getTime() + 10 * 24 * 60 * 60 * 1000);
    this.minDate = today.toISOString().slice(0, 10);
    this.maxDate = tenDaysFromNow.toISOString().slice(0, 10);
    var dueDate = new Date('dd-mm-yyyy');

    if (dueDate > today) {
      ngswal("Warning !", "Due date must be today or in the past", "warning");
    } else if (dueDate > tenDaysFromNow) {
      ngswal("Warning !", "Due date must be within 10 days from today", "warning");
    }
  }
  onuploadSelected(fileInput: any) {
    var ext = $('#doc_Defectuploadfile').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['doc', 'docx', 'pdf', 'xlsx']) == -1) {
      $('#doc_Defectuploadfile').val("");
      ngswal("Failed !", "Invalid File format", "warning");
      return false;
    } else if (fileInput.target.files[0].size > 52428800) {
      $('#doc_Defectuploadfile').val("");
      ngswal("Failed !", "Please upload File less than 50MB", "warning");
      return;
    } else {
      this.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {

        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.fileBase64 = null;
          this.fileBase64 = e.currentTarget.result;
        }
        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
      }
    }
  }
  // validation on holidays not to be selected for due date
  GetDueDateValidationOnDate() {
    // 
    let date = $("#Txt_DefectDueDate").val();


    ApiMethod.getMethod("api/GetHolidayList").subscribe(
      result => {
        let aholidayList = result.aholidayList;
        let isHoliday: boolean = false;
        let message = "";

        if (aholidayList.length != 0) {
          isHoliday = aholidayList.some(x => x.Leave_Date.slice(0, 10) == date);

        }
        var newDate = new Date(date);

        // Check for Sunday (0 th day) or holiday(from holidays list)
        if (newDate.getDay() == 0 || isHoliday) {

          message = "Holiday";
          $("#Txt_DefectDueDate").val('');

        } else { message = "Working"; }

        if (message == "Holiday") {
          ngswal("Warning !", "Its a holiday! Please select another date !", "warning");
        }
      });


  }

 
  getReportTypeList() {
    ApiMethod.getMethod("api/GetreporttypeList" + "/" + localStorage.roleId).subscribe(
      result => {
        this.reportTypeList = result.areportType;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
  GetStatusList(): void {

    ApiMethod.getMethod("api/statuslist").subscribe(
      result => {
        this.DefectStatusListAPI = result.dataItem;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed to Load Defect Status !", error.message, "error");
      });
  }

  GetDefectInstruction(): void {
    ApiMethod.getMethod("api/defectinstructionlist").subscribe(
      result => {
        this.DefectInstructionList = result.dataItem;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed to Load Defect Instruction !", error.message, "error");
      });
  }

  GetDefectAreaList(): void {
    ApiMethod.getMethod("api/defectarealist").subscribe(
      result => {
        this.DefectAreaList = result.dataItem;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed to Load Defect Area !", error.message, "error");
      });
  }

  GetJournalsList() {
    ApiMethod.getMethod("api/GetJournals" + "/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
      result => {
        this.journalList = result.aitemJournalList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  resetForm() {
    let form: NgForm = $('form');
    form[0].reset();
    $('form input').val('');

  }
  //Upload Method

  //Support File Download
  DefectDownloadFile() {
    $("#LoadingImage").show();
    var aEid = localStorage.aEID;
    ApiMethod.Downloadfile("api/DownloadDefectFile" + "/" + aEid);
    this.ShowInfoPopUp()
    this.hide();
    $("#LoadingImage").hide();
  }

  //Corrected Download File
  DefectCorrectedFile() {
    $("#LoadingImage").show();
    var aEid = localStorage.aEID;
    ApiMethod.Downloadfile("api/DownloadCorrectedFile" + "/" + aEid);
    this.ShowInfoPopUp();
    this.hide();
    $("#LoadingImage").hide();
  }
}
